import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';

@Injectable({ providedIn: 'root' })
export class ToastService {
  success(message: string) {
    toast.success(message, {
      closeButton: true,
    });
  }

  error(message: string) {
    toast.error(message, {
      closeButton: true,
    });
  }

  info(message: string) {
    toast(message, {
      closeButton: true,
    });
  }

  warning(message: string) {
    toast.warning(message, {
      closeButton: true,
    });
  }
}
